<template>
  <NavBar />
  <router-view />
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: 'defaultLayout',
  components: {
    NavBar,
  },
}
</script>
